import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fileIcon',
  standalone: true
})
export class FileIconPipe implements PipeTransform {
  private readonly fileIconsMap = new Map([
    ['pdf', 'pdf'],
    ['csv', 'csv'],
    ['xls', 'xls'],
    ['xlsx', 'xlsx'],
    ['docx', 'docx'],
    ['doc', 'doc'],
    ['docm', 'docx'],
    ['jpeg', 'jpeg'],
    ['jpg', 'jpeg'],
    ['png', 'png'],
    ['jfif', 'jpeg'],
    ['gif', 'gif'],
    ['txt', 'txt'],
    ['ppt', 'ppt'],
    ['pptx', 'ppt']
  ]);

  transform(fileName: string): string {
    const fileNameSplit = fileName.split('.');
    const fileType = fileNameSplit[fileNameSplit.length - 1].toLowerCase();

    return this.fileIconsMap.has(fileType)
      ? this.fileIconPath(this.fileIconsMap.get(fileType)!)
      : this.fileIconPath('default');
  }

  private fileIconPath(name: string) {
    return `/icons/${name}-files.svg`;
  }
}
